import React, {useState} from "react";
import Slider from "./Slider/Slider";
import CurrencyToggle from "./CurrencyToggle/CurrencyToggle";
// import MeasureToggle from "./MeasureToggle/MeasureToggle";
import Cards from "./Cards/Cards";
import GeoCurrency from "./GeoCurrency/GeoCurrency";

const Home = () => {
    const [rangeValue, setRangeValue] = useState(10000);
    const [country, setCountry] = useState("");
    const [currency, setCurrency] = useState(true);
    const [measure, setMeasure] = useState("");

    const onChangeSlider = value => {
        setRangeValue(parseInt(value, 10));
    }

    return (
        <div className="rct-content">
            <div className="rct-content__container">
                {/*<MeasureToggle value={rangeValue} handleChange={setRangeValue} measure={measure} setMeasure={setMeasure} currency={currency} setCurrency={setCurrency}/>*/}
                <CurrencyToggle currency={currency} setCurrency={setCurrency} measure={measure} setMeasure={setMeasure} rangeValue={rangeValue} handleChange={setRangeValue}/>
                <Slider
                    min={100}
                    max={100000}
                    step={1}
                    defaultLength={rangeValue}
                    value={rangeValue}
                    onChangeValue={onChangeSlider}
                    linearGradientColor="#3452ff"
                    linearGradientColorGrad="#ff1053"
                    rangeBackgroundColor="#d7dcdf"
                    sliderThumbColor="#FFFFFF"
                    currency={currency}
                    measure={measure}
                />
                <GeoCurrency setCurrency={setCurrency} setCountry={setCountry}/>
                <Cards rangeValue={rangeValue} country={country} currency={currency} measure={measure}/>
            </div>
        </div>
    );
}

export default Home;